import type { FilterMultiButtonProps } from 'components/Filters/BaseMultiButton'
import BaseMultiButton from 'components/Filters/BaseMultiButton'
import { useI18n } from 'context/I18nProvider'

export default function PreventionPassport({ value, onChange, ...props }: FilterMultiButtonProps) {
  const { i18n } = useI18n()

  return (
    <BaseMultiButton
      labels={[i18n('label.all'), i18n('label.training_prevention_passport'), i18n('label.not_eligible')]}
      onChange={onChange}
      value={value}
      options={{ 0: null, 1: 'true', 2: 'false' }}
      {...props}
    />
  )
}
